import I18n from '../../../i18n-js/index.js.erb';

let GoogleAuth; // Google Auth object.
let load = false;
function updateSigninStatus(is_sign_in){
  load = true;
  if(is_sign_in){
    let user = GoogleAuth.currentUser.get();
    window.location = "/users/google/"+user.getBasicProfile().getId()+"?accessToken="+user.getAuthResponse().id_token
  } else {
    M.toast({'html': I18n.t("user.loginup.google.not_connected")});
  }
}

function start() {
  // 2. Initialize the JavaScript client library.
  window.gapi.client.init({
    access_type: 'offline',
    redirect_uri: '/users/google',
    apiKey: 'AIzaSyAmN8hlIhJ6vKr9KFFjVT7BsaxR2YUJbJE',
    //ux_mode: 'redirect',
    // clientId and scope are optional if auth is not required.
    clientId: '139792874222-tvto6i9f5agh0p5qpng7ovkk3cqhbiok.apps.googleusercontent.com',
    scope: "email profile https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email openid",
  }).then(function() {
    GoogleAuth = gapi.auth2.getAuthInstance();
    // Listen for sign-in state changes.
    GoogleAuth.isSignedIn.listen(updateSigninStatus);
    if(GoogleAuth.isSignedIn.get()) updateSigninStatus(true);
    else GoogleAuth.signIn();
  }, function(reason) {
    M.toast({'html': I18n.t("user.loginup.google.say",{reponse: reason.details})})
  });
};

let activate = false;
function activateGoogle(){
  window.onerror = function (message, file, line, col, error) {
    load = true;
    M.toast({'html': I18n.t("user.loginup.google.say",{reponse: message})});
    console.log(file +"/"+ line +":"+ col  );
    console.log(error);
    return false;
  };

  if(window.gapi){
    // 1. Load the JavaScript client library.
    window.gapi.load('client', start);
  } else {
    if(!activate){
      (function(d, s, id){
        let js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://apis.google.com/js/api.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'google-jssdk'));
      setTimeout(()=>{
        if(!load)M.toast({'html': I18n.t("user.loginup.google.failed")});
      }, 2000);
    }
    activate = true;
    setTimeout(activateGoogle, 100);
  }
}



document.addEventListener('turbolinks:load', ()=>{
  document.querySelector("#activateGoogle").addEventListener("click",activateGoogle);
});
